/*************************************************/
/* HEADER                                        */
/*************************************************/

export function header() {
    let prevScrollPos = window.pageYOffset;
    let isAtTop = true;

    const header = document.querySelector(".header");
    const megaMenu = document.querySelectorAll(".menu-nav__mega");
    const top = window.innerWidth <= 768 ? "-80px" : "-110px";
    const stickyHeaderClass = "header-sticky";
    const stickyLogo = document.querySelector(".logo--sticky");
    const fixedLogo = document.querySelector(".logo--fixed");
    const parentActiveClass = "menu-nav__link--parent--active";
    const megaMenuActiveClass = "menu-nav__mega--active";
    
    // Throttle scroll events with requestAnimationFrame for smoother scrolling
    let ticking = false;

    function onScroll() {
        const currentScrollPos = window.scrollY;
        
        // Ensure previous scroll position is not negative
        if (prevScrollPos < 0) {
            prevScrollPos = 0;
        }

        // Scrolling down - hide the header
        if (prevScrollPos < currentScrollPos) {
            if (header.style.top !== top) {
                header.style.top = top; 
                
                clearActiveMenuItems();
            }
            isAtTop = false;
        }
        // Scrolling up - show the header
        else {
            if (!isAtTop) {
                if (!header.classList.contains(stickyHeaderClass)) {
                    activateStickyHeader(); 
                }
            }
            if (currentScrollPos > 0 && header.style.top !== "0") {
                header.style.top = "0"; 
            }
        }

        // Reset at the top of the page
        if (currentScrollPos <= 0 && !isAtTop) {
            resetHeader();
        }
    
        prevScrollPos = currentScrollPos;
        ticking = false;
    }    

    // Function to clear active menu classes
    function clearActiveMenuItems() {
        const activeHeader = document.querySelector(`.${parentActiveClass}`);
        if (activeHeader) {
            document.querySelectorAll(`.${parentActiveClass}`).forEach(item => {
                item.classList.remove(parentActiveClass);
            });
        }

        megaMenu.forEach(menu => {
            if (menu.classList.contains(megaMenuActiveClass)) {
                menu.classList.remove(megaMenuActiveClass);
            }
        });
    }

    // Function to activate sticky header
    function activateStickyHeader() {
        header.classList.add(stickyHeaderClass);
        stickyLogo.style.display = "block";
        fixedLogo.style.display = "none";
    }

    // Function to reset the header when at the top of the page
    function resetHeader() {
        header.classList.remove(stickyHeaderClass);
        stickyLogo.style.display = "none";
        fixedLogo.style.display = "block";
        isAtTop = true;
    }

    window.addEventListener('scroll', function () {
        if (!ticking) {
            window.requestAnimationFrame(onScroll);
            ticking = true;
        }
    });
}
